module.exports = __webpack_public_path__ + "img/ic_32_sport_american_football-active.a77acf16.svg";